import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FiltersService } from 'app/components/filters/filters.service';
import { DetailsService } from 'app/components/details/details.service';
import { UtilsService } from 'app/components/utils/utils.service';
import { ProductsService } from 'app/components/products/products.service';

@Component({
  selector: 'app-edit-products-categories',
  templateUrl: './edit-products-categories.component.html',
  styleUrls: ['./edit-products-categories.component.css']
})
export class EditProductsCategoriesComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  @Input() exhibitorData: object = {
    selectedCategories: []
  };

  hierarchicalProperties: Array<any> = [];
  showHierarchicalProperties: boolean = false;
  exhibitorId;
  productId

  constructor(private filtersService: FiltersService, public detailsService: DetailsService, private utilsService: UtilsService,
     private activatedRoute: ActivatedRoute, private productService: ProductsService) {
    this.exhibitorId = this.activatedRoute.snapshot.paramMap.get('exhibitorId') || null;
    this.productId = this.activatedRoute.snapshot.paramMap.get('productId') || null;
  }

  updateFilter(elem){

    let item = elem.item;
    let type = elem.type;

    type = type;
    let valueKey = 'id';
    let propertyName = this.utilsService.setPropertyName(type);

    this.exhibitorData['selectedCategories'] = this.exhibitorData['selectedCategories'] || [];

    if (item['checked']) {
      this.exhibitorData['selectedCategories'].push(item['id']);
    } else {
      let index = this.exhibitorData['selectedCategories'].indexOf(item['id']);

      if (index !== -1) {
        this.exhibitorData['selectedCategories'].splice(index, 1);
      }

    }

  }

  getHierarchicalProperties(getHierarchicalPropertiesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.filtersService.getHierarchicalProperties(getHierarchicalPropertiesIn)
      .subscribe((data: object) => {
        this.getHierarchicalPropertiesOk(data);
      },
        error => {
          this.getHierarchicalPropertiesError(error);
        });

  }

  getHierarchicalPropertiesOk(data) {
    this.loader.count--;
    this.hierarchicalProperties = data;

    let getCategoriesIn = {
      productId: this.productId
    };

    this.getCategories(getCategoriesIn);

  }

  getHierarchicalPropertiesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getCategories(getCategoriesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productService.getCategories(getCategoriesIn)
      .subscribe((data: object) => {
        this.getCategoriesOk(data);
      },
        error => {
          this.getCategoriesError(error);
        });

  }

  getCategoriesOk(data) {

    this.exhibitorData['selectedCategories'] = this.exhibitorData['selectedCategories'] || [];

    for (let i = 0; i < data['hierarchicalProperties'].length; i++) {
      this.exhibitorData['selectedCategories'].push(data['hierarchicalProperties'][i]['id']);
    }

    this.loader.count--;

    this.updatePropertiesFromService(this.exhibitorData['selectedCategories'], this.hierarchicalProperties, 'hierarchical');
    console.log(this.exhibitorData);

  }

  getCategoriesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  updatePropertiesFromService(itemsId, items, type) {

    let childsPropertyName = 'properties';

    if (type === 'hierarchical') {
      childsPropertyName = 'childHierarchicalProperties';
    }

    if (items && itemsId){

      for (let i = 0; i < items.length; i++) {

        if (itemsId.includes(items[i].id)) {
          items[i].checked = true;
        }

        items[i][childsPropertyName] = items[i][childsPropertyName] || [];

        if (items[i][childsPropertyName].length > 0) {
          this.updatePropertiesFromService(itemsId, items[i][childsPropertyName], type);
        }

      }

    }

  }

  ngOnInit() {

    let getHierarchicalPropertiesIn = {
      eventName: this.exhibitorData['eventName']
    };

    this.getHierarchicalProperties(getHierarchicalPropertiesIn);

  }

}
